import { Component } from '@angular/core';
import { NavigationService } from '@tablesready/common-ui';

@Component({
  selector: 'frontend-pull-refresh',
  templateUrl: './frontend-pull-refresh.component.html',
  styleUrls: ['./frontend-pull-refresh.component.scss'],
})
export class FrontendPullRefreshComponent {
  constructor(private readonly navService: NavigationService) {}

  startRefresh(event: any): void {
    this.navService.refresh();
  }
}
